<div id="var">
    <bm-nav-item *ngFor="let item of items" text="{{item.text}}" routerLink="{{item.link}}"  ></bm-nav-item>
  

</div>